import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.css'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditCardComponent {
  cardHolder = input<string>('CARDHOLDER NAME');
  cardNumber = input<string>('**** **** **** ****');
  expiryDate = input<string>('MM/YY');
  cardType = input<'visa' | 'mastercard'>('mastercard');
  cvv = input<string>('123');
  balance = input<string>('0');
  creditLimit = input<string>('0');

  formattedCardNumber = computed(() => {
    const value = this.cardNumber();
    const lastFour = value.slice(-4);
    return `**** **** **** ${lastFour}`;
  });

  balanceProgress = computed(() => {
    const balanceNum = parseFloat(this.balance());
    const limitNum = parseFloat(this.creditLimit());
    if (limitNum === 0) return 0;
    return (balanceNum / limitNum) * 100;
  });

  cardStyle = computed(() => {
    return this.cardType() === 'mastercard'
      ? { 'background': 'linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)' }
      : { 'background': 'linear-gradient(225deg, #1E3A8A 0%, #3B82F6 100%)' };
  });
}
